import { Timestamps } from '@extrahorizon/javascript-sdk';
import { PatientProfile } from 'utils/models';
import { PatientData } from './user';

export interface PrescriptionPackage extends Timestamps {
  description: string;
  duration: number;
  id: string;
  name: string;
  originalPrice: number;
  price: number;
  visible: boolean;
}

export interface GroupCredit extends Timestamps {
  id: string;
  creditBalances: { packageId: string; balance: number }[];
}

export enum PrescriptionType {
  Paid = 'paid',
  Free = 'free',
}

export const enum ActivationType {
  Immediate = 'immediate',
  Deferred = 'deferred',
}

export interface DeactivatePrescriptionsParameters {
  groupIds: string[];
  patient: PatientProfile;
}

export interface CreatePrescriptionParameters {
  activationType?: ActivationType;
  groupId: string;
  packageId: string;
  prescriptionType: PrescriptionType;
  reason: string;
  language: string;
  shouldSendEmail: boolean;
  emailSubject: string;
  emailBody: string;
  emailRecipient: string;
  patientData?: PatientData;
  consultedCompatibleDevices: boolean;
  usBillingConsent?: boolean;
  usBillingIcdCode?: string;
  deactivationGroupIds?: string[];
}
export interface CreatePrescriptionResponse {
  id: string;
  hash: string;
  status: string;
  creatorId: string;
  reference: string;
  groupId: string;
  packageId: string;
  duration: number;
  price: number;
  tags?: string[];
  logs: {
    old_status: string;
    new_status: string;
    timestamp: number;
  }[];
  isTemplate: boolean;
  paidTimestamp: Date;
  creationTimestamp: Date;
  updateTimestamp: Date;
}

export interface ActivePeriod {
  groupId: string;
  startTimestamp: number;
  endTimestamp: number;
}
export interface ActivePeriodConfiguration {
  activePeriods: ActivePeriod[];
  id: string;
  updateTimestamp: Date;
}
